import { Typography } from '@breetometer/components';
import { EngagementActions, ImageComponent } from 'BreetComponents';
import type { ISellAssets } from 'BreetHelpers';
import { useQRCode } from 'BreetHooks';

const AssetDetailsQR = ({ selectedAsset }: { selectedAsset?: ISellAssets }) => {
	const { qrCode } = useQRCode({ address: selectedAsset?.wallet?.address });

	return (
		<div className='asset-details-qr'>
			<div className='qr-section bg-primary-500 border-dark-navy'>
				<ImageComponent
					src={qrCode}
					id='wallet-address-qr-image'
				/>

				{selectedAsset?.wallet?.address && <Typography className='color-tertiary-400'>{selectedAsset.wallet.address}</Typography>}
			</div>

			<div className='qr-share'>
				<EngagementActions
					noReport
					isCopy
					copy={{
						item: selectedAsset?.wallet?.address ?? '',
						message: 'Wallet address copied to clipboard',
					}}
					shareContentDetails={{
						text: 'Transaction Snapshot',
						title: 'Withdrawal Receipt',
						url: 'https://breet.io',
						screenshotElementId: 'wallet-address-qr-image',
						action: 'download',
					}}
				/>
			</div>
		</div>
	);
};

export default AssetDetailsQR;
